import React from 'react'
import { Column } from 'primereact/column'
import NumericBodyTemplate from './NumericBodyTemplate'
import NumericEditor from './NumericEditor'
import NumericFilterTemplate from '../Filters/NumericFilterTemplate'
import { createFieldChangedChecker } from '../utils/createFieldChangedChecker'

const NumericColumn = ({ title, mapsToField, filter, sortable, editable, isEditable, isFieldChanged, isFieldChangedOverride, validationErrors, template, originalData, min, max }) => {
    const filterAttributes = {
        filter,
        filterPlaceholder: `Search by  ${title}`,
        required: !!filter,
        disabled: !filter
    }
    const sortAttributes = {
        sortable,
        required: !!sortable,
        disabled: !sortable
    }

    const checkFieldChanged = createFieldChangedChecker({
        editable,
        isFieldChangedOverride,
        defaultIsFieldChanged: isFieldChanged,
        mapsToField,
        originalData
    })

    return (
        <Column
            {...sortAttributes}
            key={mapsToField}
            field={mapsToField}
            header={title}
            dataType="numeric"
            body={(rowData) => (
                <span className={`${checkFieldChanged(rowData) ? 'changed-field' : ''} ${rowData.isDeleted ? 'pending-deletion' : ''}`}>
                    {template ? template(rowData) : <NumericBodyTemplate rowData={rowData} field={mapsToField} />}
                </span>
            )}
            editor={editable ? (options) => {
                // If row is not editable, show template (e.g., "NA") instead of editor
                if (isEditable && !isEditable(options.rowData)) {
                    return template ? template(options.rowData) : <NumericBodyTemplate rowData={options.rowData} field={mapsToField} />
                }
                return <NumericEditor options={options} validationErrors={validationErrors} min={min} max={max} />
            } : null}
            filterElement={(options) => <NumericFilterTemplate options={options} field={mapsToField} />}
            {...filterAttributes}/>
    )
}

export default NumericColumn
